<template>
  <v-toolbar dark prominent app>
      <img
        src="../../assets/pictures/Teutonia_Zirkel_transparent_white.png"
        alt="Vuetify.js"
        height="60"
      >
       <v-btn
        flat
        @click = toHome()
        v-scroll-to="'#uns'"
      >
        <span class="mr-2">Über Uns</span>
      </v-btn>
      <v-btn
        flat
        @click = toHome()
        v-scroll-to="'#keller'"
      >
        <span class="mr-2">Teutonenkeller</span>
      </v-btn>
      <v-btn
        flat
        @click = toHome()
        v-scroll-to="'#wg'"
      >
        <span class="mr-2">Teutonen WG</span>
      </v-btn>
       <v-menu
      bottom
      origin="center center"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on }">
        <v-btn
          color="dark"
          dark
          v-on="on"
        >
          Semesterprogramm
        </v-btn>
      </template>

      <v-list>
        <v-list-tile>
          <v-list-tile-title>
            <a class="black--text" href="/Semesterprogramm-WS26-27.pdf" download>Als PDF</a>
          </v-list-tile-title>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-title>
            <a class="black--text" href="/Semesterprogramm-WS26-27.ics" download>Als Kalender</a>
          </v-list-tile-title>
        </v-list-tile>
      </v-list>
    </v-menu>
      <v-btn
        flat
        @click = toHome()
        v-scroll-to="'#kontakt'"
      >
        <span class="mr-2">Kontakt</span>
      </v-btn>
<!--       <v-btn
        flat
        @click = toRegistration()
      >
        <span class="mr-2">Anmeldung zum Stife</span>
      </v-btn> -->

      <v-btn
        flat
        @click = toImpressum()
        v-scroll-to="'#impressum'"
      >
        <span class="mr-2">Impressum</span>
      </v-btn>
            <v-btn
        flat
        @click = toDatenschutz()
        v-scroll-to="'#datenschutz'"
      >
        <span class="mr-2">Datenschutz</span>
      </v-btn>

      <v-spacer></v-spacer>
      <!-- <v-btn
        flat
        @click="scrollToEnd(Id)"
        target="_blank"
      >
        <span class="mr-2">Interner Bereich</span>
      </v-btn> -->
    </v-toolbar>
</template>
<script>
export default {
  methods: {
    toImpressum() {
      this.$router.push({ name: 'impressum' });
    },
    toDatenschutz() {
      this.$router.push({ name: 'datenschutz' });
    },
    toHome() {
      this.$router.push({ name: 'home' });
    },
    toRegistration() {
      this.$router.push({ name: 'registration' });
    },
  },
};
</script>
